<label class="st-field-label">{{ label }}</label>
<span><b>{{currencySymbolVal}}</b></span><input [id]="idVal" class="form-control st-input-text-field" [placeholder]="placeHolderVal" type="text"
       [ngStyle]="{
          'width': width
       }"
       [value]="inputVal"
       [disabled]="disabled"
       [required]="requiredVal"
>
